export enum LanguageEnum {
  EN = 'EN',
  AL = 'AL',
  SI = 'SI',
}

export enum LanguageIDsEnum {
  EN = '2fbb5fe2e29a4d70aa5854ce7ce3e20b',
  KS = 'b80955ff390b464593237a45e9fa2d29',
  SI = '35f8c4f0e0384a0d8b8fc27754fb6f7d',
}
